import { FieldArray, FieldArrayRenderProps, Form, Formik } from 'formik';
import { DragDropContext } from 'react-beautiful-dnd';
import { Box } from '@mui/system';

import { DraggableList } from '@shared/components/draggable/DraggableList';
import { SaveButton } from '@shared/inputs/Buttons';
import { ModalFooter } from '@styles/ModalStyles';
import { SortModalStyle } from '@styles/Admin-tools/Tracker';
import { ISortOrderModal } from './interfaces';

export const SortOrderModal = ({
  formikRef,
  listItems = [],
  onClose,
  onMoveAdjustment,
  onOrderApply,
  sortModalLoading,
  sortModalPosition
}: ISortOrderModal) => (
  <SortModalStyle
    open
    hideBackdrop
    title="Sort Order"
    dialogWidth="420px"
    resetPosition={sortModalPosition}
    isSubmitting={sortModalLoading}
    onClose={onClose}
  >
    <Box padding="5px 10px">
      <Formik
        enableReinitialize
        innerRef={formikRef}
        initialValues={{ leadSortOrder: listItems }}
        onSubmit={onOrderApply}
      >
        {({ values }) => (
          <Form>
            <FieldArray
              name="leadSortOrder"
              render={({ move }: FieldArrayRenderProps) => (
                <DragDropContext onDragEnd={(result) => onMoveAdjustment(result, move)}>
                  <DraggableList droppableId="leadSortOrder" items={values.leadSortOrder} />
                </DragDropContext>
              )}
            />

            <ModalFooter margin="15px 0 0 0">
              <SaveButton label="Apply" isLoading={sortModalLoading} />
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Box>
  </SortModalStyle>
);
